import {
	OPEN_MODAL_FULFILLED, CLOSE_MODALS_FULFILLED
} from '../constants/modals.actions';

export const openModal = modal => ({
	type: OPEN_MODAL_FULFILLED,
	payload: {
		modal
	}
});

export const closeModals = () => ({
	type: CLOSE_MODALS_FULFILLED,
	payload: null
});
